import { http } from '@/shared/api';
import type { CreateItem, SearchProvider } from '@/widgets/app-shell';
import type { AccountList } from '@/entities/account';

/** Mục "Tạo mới" của module ở thanh trên (lọc theo module bật + quyền). */
export const createItems: CreateItem[] = [];

/** Tìm nhanh: tài khoản theo tên / mã nhân viên / SĐT (identity lọc theo phạm vi) ⇒ mở drawer tài khoản. */
export const searchProviders: SearchProvider[] = [
  {
    id: 'accounts',
    module: 'accounts',
    group: 'Tài khoản',
    perm: ['accounts.view'],
    search: async (q, { signal }) => {
      const r = await http.get<AccountList>('/accounts', { query: { q, pageSize: 5 }, signal });
      return r.rows.map((a) => ({
        key: a.staffId,
        icon: 'staff',
        title: a.name,
        sub: [a.code, a.roleName].filter(Boolean).join(' · '),
        to: '/tai-khoan',
        search: { account: a.staffId },
      }));
    },
  },
];
